// 模拟后端动态生成路由
import { defineFakeRoute } from "vite-plugin-fake-server/client";

// const icon_menus = {
//   warning: warning
// };
/**
 * roles：页面级别权限，这里模拟二种 "admin"、"common"
 * admin：管理员角色
 * common：普通角色
 */
const permissionRouters = [
  {
    name: "Account",
    path: "/account",
    meta: {
      title: "账号管理",
      icon: "skill"
    },
    children: [
      {
        name: "Administrator",
        path: "/account/administrator/index",
        meta: {
          title: "管理员"
        }
      },
      {
        name: "Enterprise",
        path: "/account/enterprise/index",
        meta: {
          title: "企业管理"
        }
      }
    ]
  }
] as RouteConfigsTable[];

export default defineFakeRoute([
  {
    url: "/get-async-routes",
    method: "get",
    response: () => {
      return {
        success: true,
        data: permissionRouters
      };
    }
  }
]);
